export function logAnalytics(data: Object) {
  let dataLayer = window.dataLayer ?? [];
  dataLayer.push(data);
}
